import { useEffect, useState } from 'react';

export interface HighlightedRegion {
  left: number;
  top: number;
  width: number;
  height: number;
  clicksCount: number;
  clicksPercentage: number;
}

export interface HighlightsHook {
  activate: () => void;
  deactivate: () => void;
  discardRegion: () => void;
  highlightRegion: (position: HighlightedRegion) => void;
  highlightedRegion: HighlightedRegion | null;

  isActive: boolean;
}

export function useHighlightsState<TFilters>(filters: TFilters): HighlightsHook {
  const [isActive, setIsActive] = useState(false);
  const [highlightedRegion, setHighlightedRegion] = useState<HighlightedRegion | null>(null);

  function activate() {
    setIsActive(true);
  }

  function discardRegion() {
    setHighlightedRegion(null);
  }

  // NOTE: for new data the selection may have no sense anymore
  useEffect(() => {
    discardRegion();
  }, [filters]);

  return {
    activate,
    highlightedRegion,
    deactivate() {
      setIsActive(false);
    },
    discardRegion() {
      setHighlightedRegion(null);
    },
    highlightRegion(region) {
      setHighlightedRegion(region);
      activate();
    },
    isActive,
  };
}
